import logo from './logo.svg';
import './App.css';
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { useSearchParams } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import ProductRegistrationForm from './components/page/registrationForm/ProductRegistrationForm';
import AlreadyRegistered from './components/invalidPages/AlreadyRegistered';
import DeleteAccount from './components/page/DeleteAccount';
import PrivacyPolicy from './components/page/PrivacyPolicy';
import About from './components/page/About';
import HelpCenter from './components/page/HelpCenter';  
import Home from './components/page/Home';
import TermsOfService from './components/page/TermsOfService';

function App() {
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/:productId" element={<ProductRegistrationForm />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
